import axios from './axios'
import { ListDTO } from './dto/list.dto'
import { HitparadeDTO } from './dto/hitparade.dto'

class HitparadeServiceClass {
  async list (queryParams: { [key: string]: string | number }) {
    const res = await axios.get<ListDTO<HitparadeDTO>>('/api/hitparades', {
      params: queryParams
    })
    return res.data
  }

  async detail (id: string) {
    const res = await axios.get<HitparadeDTO>(`/api/hitparades/${id}`)
    return res.data
  }

  async create (hitparade: HitparadeDTO) {
    const res = await axios.post<HitparadeDTO>('/api/hitparades', hitparade)
    return res.data
  }

  async update (hitparade: HitparadeDTO) {
    const res = await axios.put<HitparadeDTO>(`/api/hitparades/${hitparade.id}`, hitparade)
    return res.data
  }
}

const HitparadeService = new HitparadeServiceClass()

export {
  HitparadeService
}
